import { autoinject, bindable, bindingMode, customElement, transient } from 'aurelia-framework';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { Toastr } from 'Code/Extension/Toastr';
import { ObjectCompareResult, ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { ValidationHelper } from 'Code/Helpers/ValidationHelper';
import { PromptController } from 'Code/Prompts/PromptController';
import { BaseView } from 'Common/BaseView';
import { DiscussionMessageModel } from 'Common/Code/DiscussionMessage/DiscussionMessageModel';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { DataService, GetPageModeEnum } from 'DataAccessLayer/Services/DataService';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import { ValidateResult } from 'aurelia-validation';
import { GuidHelper } from 'Code/Helpers/GuidHelper';

@autoinject
@customElement('edit3')
export class Edit3CustomElement extends BaseCustomElement {

    @bindable({ defaultBindingMode: bindingMode.toView }) entityId: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityData: any = null;

    private created: string = null;
    private modified: string = null;
    private dataService: DataService = null;
    private _authService: AuthService = null;
    private promptController: PromptController = null;
    private i18n: I18N = null;
    private router: Router = null;
    private schema: any = null;
    private globalSchema: Object = null;
    private accessRight: Object = null;
    private element: any = null;
    private routeConfig: any = null;
    private quoteIssuedList: Array<any> = [];

    protected requestCounter: number = 0;

    constructor(dataService: DataService, router: Router, promptController: PromptController, i18n: I18N, authService: AuthService) {
        super();
        this.dataService = dataService;
        this.router = router;
        this.promptController = promptController;
        this.i18n = i18n;
        this._authService = authService;
    }

    async bind() {
        await this.loadData();
    }

    async loadData() {
        this.quoteIssuedList = [];
        this.requestCounter = this.requestCounter + 1;
        let columns: Array<any> = [
            {
                "ColumnName": "QuoteNumber",
                "Status": 1
            },
            {
                "ColumnName": "c_VybranyDr_FK",
                "Status": 1
            },
            {
                "ColumnName": "c_Klinika_FK",
                "Status": 1
            },
            {
                "ColumnName": "c_IsFinal",
                "Status": 1
            },
            {
                "ColumnName": "PriceWithTax",
                "Status": 1
            },
            {
                "ColumnName": "PriceWithoutTax",
                "Status": 1
            },
            {
                "ColumnName": "Opportunity_FK",
                "Status": 1
            }
            ,
            {
                "ColumnName": "Currency_FK",
                "Status": 1
            }
        ];

        let response = await this.dataService.GetFilteredSorted('QuoteIssued',
            0,
            10,
            null,
            {
                "Opportunity_FK": this.entityId
            },
            {},
            '',
            null,
            null,
            this.requestCounter,
            columns,
            null,
            false,
            GetPageModeEnum.Normal
        );

        if (ObjectHelper.IsNotNullAndUndefined(response['status'])
            && response['status'] == 'OK' && response.hasOwnProperty('data') && response['data'].draw == this.requestCounter) {

            this.quoteIssuedList = this.ArrayIs(response['data'].data) ? JSON.parse(JSON.stringify(response['data'].data)) : null;
            if (ObjectHelper.ArrayIs(this.quoteIssuedList)) {
                for (let i1 = 0; i1 < this.quoteIssuedList.length; i1++) {
                    if (ObjectHelper.ObjectIs(this.quoteIssuedList[i1].Currency_FK)) {
                        let currency1 = await SystemService.Instance.GetEntityEnumerationById('Currency', this.quoteIssuedList[i1].Currency_FK);
                        console.log(55555, currency1);
                        if (ObjectHelper.IsNotNullAndUndefined(currency1)) {
                            this.quoteIssuedList[i1].Currency_FK_Caption = currency1['IsoCode'];
                        }
                    }
                    if (ObjectHelper.ObjectIs(this.quoteIssuedList[i1].c_Klinika_FK_RecordId)) {
                        let getResponse: any = await this.dataService.GetByIdMethodMode('Clinic', this.quoteIssuedList[i1].c_Klinika_FK_RecordId, "Header");
                        if (ObjectHelper.ObjectIs(getResponse) && ObjectHelper.ObjectIs(getResponse['data'])) {
                            this.quoteIssuedList[i1].c_Klinika = JSON.parse(JSON.stringify(getResponse['data']));
                        }
                    }
                    if (ObjectHelper.ObjectIs(this.quoteIssuedList[i1].c_VybranyDr_FK_RecordId)) {
                        let getResponse: any = await this.dataService.GetByIdMethodMode('Doctor', this.quoteIssuedList[i1].c_VybranyDr_FK_RecordId, "Header");
                        if (ObjectHelper.ObjectIs(getResponse) && ObjectHelper.ObjectIs(getResponse['data'])) {
                            this.quoteIssuedList[i1].c_VybranyDr = JSON.parse(JSON.stringify(getResponse['data']));
                        }
                    }
                }
            }
        }
    }
}